import React, {Component} from 'react';
import { BASIC_SEARCH, ADVANCED_SEARCH, BASIC_SEARCH_MESSAGE, BASIC_SEARCH_TYPE, SESSION_BASELINEAGENT, BASIC_SEARCH_MESSAGE_BASELINEAGENT } from "../../../../shared/Constants";
import Input from '../../../../UI/Input/Input';
import Button from '../../../../UI/Button/Button';
import classes from './QuickSearch.css';
import { LS_BASIC_SEARCH_KEY } from '../../../../shared/Constants';
import { connect } from 'react-redux';

class QuickSearchForm extends Component {

    state = {
        searchForm: {
            quickSearchKeyword: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id: 'quickSearchKeyword',
                    placeholder: 'search',
                    maxLength: 101
                },
                value: '',
                validation: {
                    required: false,
                    minlength: 2,
                    maxlength: 100,
                    nospace: true,
                    specialchar: ['<','"',':',';','=','\\','*','&','(',')','#', ',']
                },
                valid: false,
                touched: false,
                label: null,
                quickSearchInput: true,
                inputType: "QuickSearch"
            }
        },
        formHeader: BASIC_SEARCH,
        linkLabel: ADVANCED_SEARCH,
        msg: BASIC_SEARCH_MESSAGE,
        formIsValid: false
    }

    componentDidMount() {
        // console.log("[QuickSearchForm] componentDidMount", this.props);

        let data = {};
        if (this.props.agentDetails.userType === SESSION_BASELINEAGENT) {
        
            data = {
                linkLabel: this.state.linkLabel,
                formHeader: this.state.formHeader,
                formMessage: BASIC_SEARCH_MESSAGE_BASELINEAGENT
            };
    
            
        } else {
            data = {
                linkLabel: this.state.linkLabel,
                formHeader: this.state.formHeader,
                formMessage: BASIC_SEARCH_MESSAGE
            };
        }
        this.props.headerHandler(data);
        this.setSearchString();

    }

    componentDidUpdate() {
        //Works for back button , as per req we need to persist last searched query with result when agents click on back button
        window.onpopstate = e => {
            this.setBackNavigationSearchString();
            this.props.setSearchResults();
          }
          let data = {};
        if (this.props.agentDetails.userType === SESSION_BASELINEAGENT) {
        
            data = {
                linkLabel: this.state.linkLabel,
                formHeader: this.state.formHeader,
                formMessage: BASIC_SEARCH_MESSAGE_BASELINEAGENT
            };
    
            
        } else {
            data = {
                linkLabel: this.state.linkLabel,
                formHeader: this.state.formHeader,
                formMessage: BASIC_SEARCH_MESSAGE
            };
        }
        this.props.headerHandler(data);
    }

    setSearchString = () => {
        this.applySearchedKeyToForm(this.props.searchedKey)
    }

    /*
        Back navigation restores from the local storage copy, which outlives a reload,
        while the mount path above intentionally uses the in-memory request only.
    */
    setBackNavigationSearchString = () => {
        this.applySearchedKeyToForm(this.props.backNavigationSearchedKey || this.props.searchedKey)
    }

    applySearchedKeyToForm = (searchedKey) => {
        if (searchedKey) {
            const quickSearchKeyword = {
                ...this.state.searchForm.quickSearchKeyword,
                value: searchedKey,
                touched: true
            };
            quickSearchKeyword.valid = this.checkValidity(quickSearchKeyword.value, quickSearchKeyword.validation);
            this.setState({
                searchForm: {...this.state.searchForm, quickSearchKeyword},
                formIsValid: quickSearchKeyword.valid
            })
        }
    }

    inputChangedHandler = (event, inputIdentifier) => {

        // console.log("[QuickSearch] inputChangedHandler");

        let updatedForm = {...this.state.searchForm};

        const updatedFormElement = { ...updatedForm[inputIdentifier] };
        updatedFormElement.value = event.target.value;

        if(event.target.value) {
            updatedFormElement.valid = this.checkValidity(updatedFormElement.value, updatedFormElement.validation);
        } else {
            updatedFormElement.valid = true;
            this.props.errorHandler(null);
        }
        updatedFormElement.touched = true;
        updatedForm[inputIdentifier] = updatedFormElement;

        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            formIsValid = event.target.value && updatedForm[inputIdentifier].valid && formIsValid;
        }

        this.setState({searchForm: updatedForm, formIsValid: formIsValid});
    }

    checkValidity (value, rules) {

        let isValid = true;
        let message = null;

        if(rules.required) {
            isValid = value.trim() !== '' && isValid;
            // console.log("[QuickSearch] checkvalidity: required"+rules.required, value, isValid);
        }

        if(rules.minlength) {
            isValid = value.length >= rules.minlength && isValid;
            // console.log("[QuickSearch] checkvalidity: minlength"+rules.minlength, value, isValid);
            message = !isValid & message===null?"Min "+rules.minlength+" characters required":message;
        }

        if(rules.maxlength) {
            isValid = value.length <= rules.maxlength && isValid;
            // console.log("[QuickSearch] checkvalidity: maxlength"+rules.maxlength, value.length, isValid);
            message = !isValid & message===null?"Max "+rules.maxlength+" characters allowed":message;
        }

        if(rules.nospace) {
            isValid = (value.indexOf(' ')<0) && isValid;
            // console.log("[QuickSearch] checkvalidity: nospace"+rules, value, isValid);
            // message="No spaces allowed";
            message = !isValid & message===null?"No spaces allowed":message;
        }

        if(rules.specialchar) {
            // let containsSpecial = false;
            rules.specialchar.map(char => {
                return isValid = (value.indexOf(char)<0) && isValid;
            });
            // console.log("[QuickSearch] checkvalidity: specialchar", value, isValid);
            message = !isValid & message===null?"Contains invalid special characters":message;
        }

        // console.log("[QuickSearch] isvalid message ", message);
        this.props.errorHandler({message: message});

        return isValid;
    }

    quickSearchHandler = (event) => {
        event.preventDefault();
        this.props.resetSearch();
        let formData = {
            searchType: BASIC_SEARCH_TYPE
        };
        for(let formElementIdentifier in this.state.searchForm) {
            formData[formElementIdentifier] = this.state.searchForm[formElementIdentifier].value;
        }

        this.props.searched(formData);
    }

    clearSearch = (event) => {
        /*
            This function makes sure to clear the local storage for advance search
            and clear the input values in the current state
        */
       event.preventDefault();
       localStorage.removeItem(LS_BASIC_SEARCH_KEY)
       this.props.clearPersistedSearch && this.props.clearPersistedSearch()
       let searchForm = {...this.state.searchForm}
        if (searchForm['quickSearchKeyword'] && searchForm['quickSearchKeyword'].value) {
            searchForm['quickSearchKeyword'].value = "";
            searchForm['quickSearchKeyword'].touched = false;
        }
    
       this.setState({searchForm, formIsValid: false})
       this.props.resetSearch();
    }

    render() {

        // console.log("[QuickSearch] Render");

        const formsElementsArray =[];

        for(let key in this.state.searchForm) {
            formsElementsArray.push({
                id: key,
                config: this.state.searchForm[key]
            });
        }

        let searchForm = (
            <form onSubmit={this.quickSearchHandler}>
                <div>
                    {formsElementsArray.map(formElement => (
                        <Input
                            key={formElement.id}
                            elementType={formElement.config.elementType}
                            elementConfig={formElement.config.elementConfig}
                            value={formElement.config.value}
                            invalid={!formElement.config.valid}
                            shouldValidate={formElement.config.validation}
                            touched={formElement.config.touched}
                            label={formElement.config.label}
                            changed={(event) => this.inputChangedHandler(event, formElement.id)}
                            // quickSearchInput={formElement.config.quickSearchInput}
                            inputType={formElement.config.inputType}
                        />
                    ))}
                </div>
                <div style={{display:'flex', justifyContent:'center'}}>
                 <Button id="cancelSearch" btnType="Cancel" clicked={this.clearSearch} attr={{type: "button"}}>Cancel</Button>
                 <Button id="quickSearch" btnType="Search" disabled={!this.state.formIsValid}>Search</Button>
                </div>
            </form>
        );

        return <div className={classes.QuickSearch}>{searchForm}</div>;
    }
}

const mapStateToProps = state => {
    return{
        agentDetails : state.usr.user
    }
};

export default connect(mapStateToProps, null)(QuickSearchForm);